import React, { useState } from "react"
import { Link } from "gatsby"
import { Menu } from "antd"
import { ChevronDown, Search } from "../Icon"

import "./MainNav.less"
import useMenus from "../../hooks/useMenus"

const { SubMenu } = Menu

function MenuDesktop({ setShowSearch }) {
  const menus = useMenus()
  const [state, setState] = useState({
    current: "",
    visible: false,
  })

  const handleClick = e => {
    setState(p => ({ ...p, current: e.key }))
  }

  const { current } = state

  return (
    <>
      <Menu
        onClick={handleClick}
        selectedKeys={[current]}
        mode="horizontal"
        className="header-menu"
      >
        {menus.map(function (item, i) {
          const { submenu, title, key, link } = item
          if (submenu !== undefined) {
            return (
              <SubMenu key={key} title={title} icon={<ChevronDown />}>
                {submenu.map(function (child, index) {
                  if (child.submenu !== undefined) {
                    return (
                      <SubMenu key={index} title={child.title}>
                        {child.submenu.map(function (subchild, index) {
                          return (
                            <Menu.Item key={subchild.key}>
                              <Link to={subchild.link}>{subchild.title}</Link>
                            </Menu.Item>
                          )
                        })}
                      </SubMenu>
                    )
                  } else {
                    return (
                      <Menu.Item key={child.key}>
                        <Link to={child.link}>{child.title}</Link>
                      </Menu.Item>
                    )
                  }
                })}
              </SubMenu>
            )
          } else {
            return (
              <Menu.Item key={key}>
                <Link to={link}>{title}</Link>
              </Menu.Item>
            )
          }
        })}
        <Menu.Item key="search" onClick={() => setShowSearch(true)}>
          <Search />
        </Menu.Item>
      </Menu>
    </>
  )
}

export default MenuDesktop
